import React, {
  ForwardRefRenderFunction,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";

import SendCommunicationModal, {
  SendCommunicationModalHandle,
} from "../../../../../components/Generic/SendCommunicationModal";
import { useActionQuote } from "../../../../../hooks/useActionQuote";
import { Customer } from "../../../../../models/customer";
import { Sales } from "../../../../../models/sales";
import { UsedInEmailTemplates } from "../../../../../util/enums";

interface SendToCustomerProps {
  onRefetch?: () => void;
}

export interface SendToCustomerQuoteHandle {
  onOpen: (jobId: number, quote: Sales, customer?: Customer) => void;
}

const SendToCustomerModalQuote: ForwardRefRenderFunction<
  SendToCustomerQuoteHandle,
  SendToCustomerProps
> = (props, ref) => {
  const { onRefetch } = props;
  const { sendToCustomerLoading, sendToCustomer } = useActionQuote();
  const modalRef = useRef<SendCommunicationModalHandle>(null);

  useImperativeHandle(ref, () => ({
    onOpen: (jobId: number, quote: Sales, customer?: Customer) => {
      modalRef.current?.onOpen({
        entityType: 'quote',
        entityId: jobId,
        entity: quote,
        customer,
      });
    },
  }));

  const handleSendCustomerPortalLink = (entityId: number) => {
    sendToCustomer(entityId);
  };

  return (
    <SendCommunicationModal
      ref={modalRef}
      onRefetch={onRefetch}
      onSendCustomerPortalLink={handleSendCustomerPortalLink}
      isSendingCustomerPortalLink={sendToCustomerLoading}
      usedIn={UsedInEmailTemplates.QUOTES}
    />
  );
};

export default forwardRef(SendToCustomerModalQuote);
